import React, { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "../ThemeButton/ThemeButton";
import "./bulkUpload.css";
import XIcon from "../../assets/images/XIcon.svg";
import ExcelIcon from "../../assets/images/excelIcon.svg";
import DownloadIcon from "../../assets/images/icons/download.svg";
import ContentData from "../../constants/contentFile.json";
const BulkUpload = ({
  show,
  setShow,
  handleSubmit,
  handleCancel,
  handleDownloadExcel,
  onChange,
  accept,
  onClearFile,
  errorCount,
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const [isUploadComplete, setIsUploadComplete] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadError, setUploadError] = useState(null);
  const [fileName, setFileName] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);

  const handleDragEnter = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);
    const file = event.dataTransfer.files[0];
    handleFile(file);
  };

  const handleFile = (file) => {
    setIsUploadComplete(false);
    setUploadProgress(0);
    setUploadError(null);

    if (file) {
      setFileName(file.name);
      onChange(file);
      setSelectedFile(file);
      simulateExcelUpload(file);
    } else {
      setFileName("");
      onChange(null);
      setSelectedFile(null);
      setIsUploadComplete(false);
    }
  };

  const simulateExcelUpload = (file) => {
    const validMimeTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
    const validExtensions = [".xls", ".xlsx"];
    const fileExtension = file.name
      .substring(file.name.lastIndexOf("."))
      .toLowerCase();
    const isValidFileType =
      validMimeTypes.includes(file.type) &&
      validExtensions.includes(fileExtension);
    const maxFileSizeInKB = 5 * 1024; // 5MB

    if (!isValidFileType) {
      setUploadError(ContentData.bulkUpload.invalidFileType);
      setIsUploadComplete(false);
      return;
    }

    if (file.size > maxFileSizeInKB * 1024) {
      setUploadError(ContentData.bulkUpload.excelFileSize);
      setIsUploadComplete(false);
      return;
    }

    const duration = 2000;
    const intervalDuration = 100;
    const totalIntervals = duration / intervalDuration;
    const progressIncrement = 100 / totalIntervals;

    let progress = 0;
    const interval = setInterval(() => {
      progress += progressIncrement;
      setUploadProgress(Math.min(progress, 100));

      if (progress >= 100) {
        clearInterval(interval);
        setIsUploadComplete(true);
        setUploadError(null);
      }
    }, intervalDuration);
  };
  const handleFileChange = (event) => {
    const file = event.target.files?.[0] || null;
    handleFile(file);
  };

  return (
    <div className="bulk-upload">
      <Modal show={show} className="alertBoxModal popupAlert bulk-upload">
        <div className="contentContainerConfirmAlert">
          <Modal.Body>
            <div className="upload-container">
              <div
                className={`drop-zone ${isDragging ? "drag-active" : ""}`}
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
                onClick={() => fileInputRef.current?.click()}
              >
                <input
                  type="file"
                  ref={fileInputRef}
                  accept={accept}
                  onChange={handleFileChange}
                  className="hidden"
                />
                <div className="upload-content">
                  <img src={ExcelIcon} alt="Upload Icon" />
                  <div className="drop-file-text">
                    {ContentData.bulkUpload.dropFile}{" "}
                    <span>{ContentData.bulkUpload.browse}</span>{" "}
                  </div>
                  <div className="xl-text">{ContentData.bulkUpload.xlFile}</div>
                </div>
              </div>
            </div>
            {/* upload progress */}
            {selectedFile && (
              <div className="progress-container">
                <div className="file-name">{fileName}</div>
                <div className="progress-bar-container">
                  <div className="progress-bar">
                    <div
                      className="progress"
                      style={{ width: `${uploadProgress}%` }}
                    />
                  </div>
                  <button
                    onClick={() => {
                      onClearFile();
                      setSelectedFile(null);
                      setIsUploadComplete(false)
                    }}
                    className="remove-btn"
                    aria-label="Remove file"
                  >
                    <img src={XIcon} alt="Remove Icon" />
                  </button>
                </div>
                {uploadError && (
                  <div className="uploaded-error">{uploadError}</div>
                )}
              </div>
            )}
            {/* error count */}
            {errorCount && (
              <div className="error-section">
                <div className="error-text">
                  <span className="error-count">{errorCount} </span>
                  {ContentData.bulkUpload.errorFound}
                </div>
                <div className="download-error-excel">
                  <div className="">{ContentData.bulkUpload.downloadExcel}</div>
                  <button
                    onClick={handleDownloadExcel}
                    className="download-button"
                  >
                    <img src={DownloadIcon} />
                  </button>
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <div className="footer-upload-button">
              <div className="cancelBtns">
                <Button
                  value="Cancel"
                  onClick={() => {
                    handleCancel();
                    setSelectedFile(null);
                    setIsUploadComplete(false)
                  }}
                />
              </div>
              <Button
                value="Upload"
                onClick={handleSubmit}
                disabled={isUploadComplete ? false : true}
              />
            </div>
          </Modal.Footer>
        </div>
      </Modal>
    </div>
  );
};

export default BulkUpload;
